import { DatePipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IAnalogIOExtenderList } from '../../../../../models/io-extender';
import { Functions } from '../../../../../services/shared/functions';
import { IconsStyles } from '../../../../../services/shared/icons-styles';

@Component({
  selector: 'app-analog-io',
  imports: [TableModule, PanelModule, DatePipe, CardModule],
  templateUrl: './analog-io.html',
  styleUrl: './analog-io.css',
})
export class AnalogIo implements OnInit {
  analogExtenders = input.required<IAnalogIOExtenderList>();
  columns: string[] = [];
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);

  ngOnInit(): void {
    this.columns.push('Place', 'Status');
    for (let i = 0; i < this.analogExtenders().digitalInputsAmount; i++) {
      this.columns.push(`Input ${i + 1}`);
    }

    for (let i = 0; i < this.analogExtenders().digitalOutputsAmount; i++) {
      this.columns.push(`Output ${i + 1}`);
    }

    for (
      let i = 0;
      i < this.analogExtenders().analogCurrentOutputsAmount;
      i++
    ) {
      this.columns.push(`Current Out ${i + 1}`);
    }

    for (let i = 0; i < this.analogExtenders().analogCurrentInputsAmount; i++) {
      this.columns.push(`Current In ${i + 1}`);
    }
    this.columns.push('Last Update');
  }
}
